import React from "react";
import "./header.css";
import { Back } from "../icons/back";
import { Close } from "../icons/close";

interface HeaderProps {
  title: string;
  actionText?: string;
  onActionClick?: () => void;
  onBackClick?: () => void;
  showBackIcon?: boolean;
  showCloseIcon?: boolean;
  onClose?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  title,
  actionText,
  onActionClick,
  onBackClick,
  showBackIcon = true,
  showCloseIcon = false,
  onClose,
}) => (
  <div className="header">
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "16px",
      }}
    >
      {showBackIcon && <Back onClick={onBackClick} />}
      <span className="headertext">{title}</span>
    </div>
    {actionText && (
      <button className="header-action" onClick={onActionClick}>
        {actionText}
      </button>
    )}
    {showCloseIcon && <Close onClick={onClose} />}
  </div>
);

export default Header;
